module.exports = __webpack_public_path__ + "static/media/welcome.bee9cd69.jpg";